import { Maybe } from '@csp/csp-common-model';
import { useVideoTrainingConsent } from '../../consent/hook/useVideoTrainingConsent';
import { getGenericConsentVideo } from '../../../common/util/content/getGenericConsentVideo';
import { CspPath } from '../../../CspPath';

type VideoTrainingMeta = {
  url: string;
  title: string;
  versionPublishedDate: Maybe<string>;
};

export const useVideoTrainingMeta = (): Maybe<VideoTrainingMeta> => {
  const { consent } = useVideoTrainingConsent();
  const videoTrainingDocument = consent?.consentType && getGenericConsentVideo(consent.consentType, consent.version);

  if (!videoTrainingDocument) {
    return undefined;
  }

  return {
    url: `${CspPath.VIDEO_PLAYER}?title=${videoTrainingDocument.title}&uri=${encodeURIComponent(
      videoTrainingDocument.videoUrl,
    )}`,
    title: videoTrainingDocument.header,
    versionPublishedDate: videoTrainingDocument.versionPublishedDate,
  };
};
